import React, { FC, MouseEventHandler, useRef } from "react"

import { wownetApi } from "@shared/apis"
import { WOWNET_CONTENT } from "@shared/constants"
import { useAccount, useSchedule } from "@shared/contexts"

import { WownetContentType } from "live/constants"

import Button from "./Button"
import WithOpenLoginPopup from "./WithOpenLoginPopup"

const POLLING_POPUP_CLOSED = 1000 * 1

interface Props {
  getPartnerInfo(): void
  isAlarmOn?: boolean
}

const BroadcastNoti: FC<Props> = ({ getPartnerInfo, isAlarmOn }) => {
  const { schedule } = useSchedule()
  const {
    account: { viewer },
  } = useAccount()

  const settingWindow = useRef<Window | null>(null)
  const streamerUsername = schedule?.user.username
  const username = viewer?.username

  const handleNotification: MouseEventHandler = async (e) => {
    e.preventDefault()

    if (isAlarmOn) {
      await wownetApi.cancelAlarm(streamerUsername!, username!)
      getPartnerInfo()
      return
    }

    settingWindow.current = window.open(
      `${WOWNET_CONTENT.link}/?Type=${WownetContentType.ALARM}&analid=${streamerUsername}`,
    )

    const popupTick = setInterval(function () {
      if (settingWindow.current?.closed) {
        clearInterval(popupTick)
        getPartnerInfo()
      }
    }, POLLING_POPUP_CLOSED)
  }

  return (
    <WithOpenLoginPopup>
      <Button
        label="공개방송 알림"
        className="quickBrodacastNoti"
        onClick={handleNotification}
        off={!isAlarmOn}
      />
    </WithOpenLoginPopup>
  )
}

export default BroadcastNoti
